export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex-shrink-0 w-28 h-28 md:w-32 md:h-32 rounded-3xl bg-gradient-to-br from-primary-400 to-primary-600 flex items-center justify-center">
            <i className="ri-smartphone-line text-4xl md:text-5xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-3">
              随时随地追剧
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">移动观影</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              玫瑰视频完美适配手机与平板浏览，无需下载任何APP，打开浏览器即可享受高清流畅的追剧体验。
              香蕉视频、糖豆视频、小蓝视频和蓝莓视频的热门资源随时随地触手可及。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer">
                <i className="ri-android-line"></i>
                Android 入口
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line"></i>
                iOS 入口
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}